export default __webpack_public_path__ + "static/media/TeamNitrox_FirstDIV.d4f0a455.webp";